export const timeFormat = 'MMMM Do YYYY, h:mm a';
